import { InstallmentsSimulation } from './InstallmentsSimulation';
export default InstallmentsSimulation;
